import { Chip } from 'components/DesignSystem/Chip';
import classes from 'components/widgets/ReportsHome/ReportsTemplates/components/TemplateCard/components/TemplateTagsWithVisibleLimit/TemplateTagsWithVisibleLimit.module.scss';

const TAG_LIMIT = 3;

interface Props {
    tags: string[];
}

export const TemplateTagsWithVisibleLimit = ({ tags }: Props) => {
    const visibleTags = tags.slice(0, TAG_LIMIT);
    const hiddenCount = Math.max(0, tags.length - TAG_LIMIT);

    if (tags.length === 0) return null;
    return (
        <div className={classes.tagsContainer}>
            <div className={classes.tags}>
                {visibleTags.map((tag) => (
                    <Chip key={tag} label={tag} type={'default'} />
                ))}
            </div>
            {hiddenCount > 0 && <div className={classes.hiddenCount}>{`+${hiddenCount}`}</div>}
        </div>
    );
};
